'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mobileNavPadding = exports.toggleSearch = exports.closeFlyout = exports.openFlyout = exports.toggleMobileNav = exports.closeMobileNav = exports.openMobileNav = exports.closeSubnav = exports.openSubnav = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _handlers = require('scripts/components/Overlay/handlers');

var _handlers2 = require('scripts/components/Scroll/handlers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var openSubnav = exports.openSubnav = function openSubnav($this) {
  $this.addClass('is-active');
  (0, _handlers2.scrollLock)();
};

var closeSubnav = exports.closeSubnav = function closeSubnav($this) {
  $(_Dom2.default.dropdownTrigger).removeClass('is-active');
  (0, _handlers2.scrollUnlock)();
};

var openMobileNav = exports.openMobileNav = function openMobileNav() {
  $(_Dom2.default.drawer).addClass('is-open');
  $(_Dom2.default.drawerTrigger).addClass('is-open');
  (0, _handlers2.scrollLock)();
};

var closeMobileNav = exports.closeMobileNav = function closeMobileNav() {
  $(_Dom2.default.drawer).removeClass('is-open');
  $(_Dom2.default.flyout).removeClass('is-open');
  $(_Dom2.default.drawerTrigger).removeClass('is-open');
  $(_Dom2.default.promoBar).css('z-index', '100');
  $(_Dom2.default.drawer).css('z-index', '1');
  (0, _handlers2.scrollUnlock)();
};

var toggleMobileNav = exports.toggleMobileNav = function toggleMobileNav() {
  if ($(_Dom2.default.drawer).hasClass('is-open')) {
    closeMobileNav();
  } else {
    openMobileNav();
  }
};

var openFlyout = exports.openFlyout = function openFlyout($trigger) {
  $trigger.next($(_Dom2.default.flyout)).addClass('is-open');
  $(_Dom2.default.promoBar).css('z-index', '1');
  $(_Dom2.default.drawer).css('z-index', '100');
};

var closeFlyout = exports.closeFlyout = function closeFlyout() {
  $(_Dom2.default.flyout).removeClass('is-open');
  $(_Dom2.default.promoBar).css('z-index', '100');
  $(_Dom2.default.drawer).css('z-index', '1');
};

var toggleSearch = exports.toggleSearch = function toggleSearch() {
  $(_Dom2.default.mobileSearchForm).toggleClass('is-open');
};

var mobileNavPadding = exports.mobileNavPadding = function mobileNavPadding() {
  var headerHeight = $(_Dom2.default.header).outerHeight();
  var promoBarHeight = $(_Dom2.default.promoBar).outerHeight();
  var htmlPosition = $('html')[0].style.top;
  var padding = void 0;

  if (parseInt(htmlPosition) < 0) {
    padding = headerHeight;
  } else {
    padding = headerHeight + promoBarHeight;
  }

  $(_Dom2.default.drawer).css('padding-top', padding);
};